import { EVENT_TYPE, type EventType } from '@/types/dtos/events/event-type.enum';
import {
  Groups2Outlined,
  StadiumOutlined,
  QuestionMarkOutlined,
  HandymanOutlined,
  ForumOutlined,
  LocalFireDepartmentOutlined,
  ElectricBoltOutlined,
  Diversity3Outlined,
  InterpreterModeOutlined,
  TrendingUpOutlined,
  EmojiEventsOutlined,
  SchoolOutlined,
  FitnessCenterOutlined,
  NaturePeopleOutlined,
  RocketLaunchOutlined,
  ExploreOutlined,
} from '@mui/icons-material';
import type { ReactNode } from 'react';

export function eventTypeToIcon(type: EventType): ReactNode {
  switch (type) {
    case EVENT_TYPE.MEETING:
      return <Groups2Outlined />;
    case EVENT_TYPE.FORUM_ROUNDTABLE:
      return <ForumOutlined />;
    case EVENT_TYPE.FIRESIDE_CHAT:
      return <LocalFireDepartmentOutlined />;
    case EVENT_TYPE.HACKATHON_JAM:
      return <ElectricBoltOutlined />;
    case EVENT_TYPE.TOPIC_MEETUP:
      return <Diversity3Outlined />;
    case EVENT_TYPE.SYMPOSIUM:
      return <InterpreterModeOutlined />;
    case EVENT_TYPE.CONFERENCE:
      return <StadiumOutlined />;
    case EVENT_TYPE.SUMMIT:
      return <TrendingUpOutlined />;
    case EVENT_TYPE.CEREMONY:
      return <EmojiEventsOutlined />;
    case EVENT_TYPE.SEMINAR:
      return <SchoolOutlined />;
    case EVENT_TYPE.TRAINING:
      return <FitnessCenterOutlined />;
    case EVENT_TYPE.WORKSHOP:
      return <HandymanOutlined />;
    case EVENT_TYPE.RETREAT_OFFSITE:
      return <NaturePeopleOutlined />;
    case EVENT_TYPE.PRODUCT_LAUNCH:
      return <RocketLaunchOutlined />;
    case EVENT_TYPE.EXPERIENCE:
      return <ExploreOutlined />;
    default:
      return <QuestionMarkOutlined />;
  }
}
